var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled, { css } from 'styled-components';
var SubscribeBlock = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var margin = _a.margin, padding = _a.padding;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    font-size: 12px;\n    line-height: 18px;\n    display: flex;\n    cursor: pointer;\n    width: fit-content;\n    margin: ", ";\n    padding: ", ";\n  "], ["\n    font-size: 12px;\n    line-height: 18px;\n    display: flex;\n    cursor: pointer;\n    width: fit-content;\n    margin: ", ";\n    padding: ", ";\n  "])), margin || 0, padding || 0);
});
export default SubscribeBlock;
var templateObject_1, templateObject_2;
